import { jsx as _jsx } from "react/jsx-runtime";
const skeletonStyle = {
  backgroundColor: '#eaf0f6',
  borderRadius: '999px',
  display: 'inline-block',
  height: '0.8em',
  width: '6em'
};
export const SkeletonText = () => /*#__PURE__*/_jsx("div", {
  "data-testid": "loading",
  style: skeletonStyle
});